var Chart = require("chart.js");

$(document).ready(function (e) {

    if ($(".e-bar-graph").length > 0) {
      
        var chart_loader = $(".e-bar-graph").find(".loader");
        var bargraph_chart = $(".e-bar-graph__canvas canvas");
        var bargraph_chart_data = {};
        var bargraph_chart_object = null;

        if (bargraph_chart.length > 0) {

            // get chart data
            bargraph_chart_data = JSON.parse(bargraph_chart.attr("data-json"));

            // console.log(bargraph_chart_data);

            // create chart
            bargraph_chart_object = new Chart(bargraph_chart, {
                type: "bar",
                data: {
                    labels: bargraph_chart_data.labels,
                    datasets: bargraph_chart_data.data,
                },
                options: {
                    legend: {
                        position: "top",
                        labels: {
                            fontFamily: "Montserrat",
                            fontSize: 15,
                            fontColor: "#000",
                            usePointStyle: true,
                            padding: 20,
                        },
                        onClick: function (e, legendItem) {
                            // change default click behaviour
                            // on click of legend, hide other datasets
                            var index = legendItem.datasetIndex;
                            var ci = this.chart;
                            var alreadyHidden = (ci.getDatasetMeta(index).hidden === null) ? false : ci.getDatasetMeta(index).hidden;

                            ci.data.datasets.forEach(function(e, i) {
                                var meta = ci.getDatasetMeta(i);

                                if (i !== index) {
                                    if (!alreadyHidden) {
                                        meta.hidden = meta.hidden === null ? !meta.hidden : null;
                                    } else if (meta.hidden === null) {
                                        meta.hidden = true;
                                    }
                                } else if (i === index) {
                                    meta.hidden = null;
                                }
                            });

                            ci.update();    
                        },
                    },
                    scales: {
                        xAxes: [{
                            stacked: true
                        }],
                        yAxes: [{
                            stacked: true
                        }]
                    },
                    responsive: true,
                },
            });

            chart_loader.hide();
        }
    }


    /***
     * Filter graph
     */
    function FilterBarGraph() {

        // on click of filter buttons
        $(".e-bar-graph__button").click(function (e) {
            e.preventDefault();

            $(".e-bar-graph__button").removeClass("e-bar-graph__button--selected");
            $(this).toggleClass("e-bar-graph__button--selected");

            // get form, element and range
            // var form = $(this).parent("form.e-bar-graph__filter-form");
            var elementID = $(this).data('elementid');
            var datatopass = $(this).data('range');
            

            // get all data for current graph
            // Get data in 'dates' and 'values' arrays
            $.ajax({
                type: "POST",
                url: window.location.pathname + "bargraphelementdata/" + elementID,
                data: {range: datatopass},
                success: function (data) {
                    
                    // convert JSON to JS value
                    var getData = JSON.parse(data);

                    // update graph
                    // console.log(getData);
                    bargraph_chart_object.data.labels = getData.labels;
                    bargraph_chart_object.data.datasets = getData.data;
                    bargraph_chart_object.update();
                }
            })

        });
    

        // $(".e-bar-graph__submit").click(function (e) {
        //     e.preventDefault();

        //     // get form
        //     var form = $(this).parent("form.e-bar-graph__filter-form");
        //     var elementID = $(this).data('elementid');
        //     var datatopass = form.serialize();

        //     // get all data for current graph
        //     // Get data in 'dates' and 'values' arrays
        //     $.ajax({
        //         type: "POST",
        //         url: window.location.pathname + "bargraphelementdata/" + elementID,
        //         data: datatopass,
        //         success: function (data) {
                    
        //             // convert JSON to JS value
        //             var getData = JSON.parse(data);

        //             // update graph
        //             console.log(getData);
        //             bargraph_chart_object.data.labels = getData.labels;
        //             bargraph_chart_object.data.datasets = getData.data;
        //             bargraph_chart_object.update();
        //         }
        //     })
        // });
    }

    FilterBarGraph();
});
